<template>
  <div class="flex-auto page-padding newpassword-page">
    <!-- <el-button class="back" type="text"
               @click="reback">返回</el-button> -->
    <!-- <div class="identify-tar-title">重置密码</div> -->
    <div class="newpassword-main">
      <div class="newpassword-container">
        <el-form class="newpassword-form">
          <el-form-item class="form-item">

            <div class="newpassword-title">重置密码</div>
          </el-form-item>
          <el-form-item>

            <div class="newpassword-label">请设置
              <span class="account-number">{{accountNumber}}</span>的新密码，建议用数字、字母的组合密码，提高密码安全等级
            </div>
          </el-form-item>
          <el-form-item class="form-item form-code">
            <span class="form-input-icon"><i class="iconfont icon-password"></i></span>
            <el-input :type="passw"
                      class="input-text form-input"
                      clearable
                      @clear="clearText('password')"
                      v-model="param.password"
                      placeholder="请输入密码">
              <i slot="suffix"
                 :class="icon"
                 @click="showPass"></i>
            </el-input>
            <span class="form-input-icon"></span>
          </el-form-item>
          <el-form-item class="form-item form-code">
            <span class="form-input-icon"><i class="iconfont icon-password"></i></span>
            <el-input :type="confirmpassw"
                      class="input-text form-input"
                      clearable
                      @clear="clearText"
                      v-model="param.confirmPassword"
                      placeholder="请再次确认密码">
              <i slot="suffix"
                 :class="icon1"
                 @click="showPass1"></i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       class="sign-button"
                       :loading="loading"
                       @click="confirm">
              确定
            </el-button>
          </el-form-item>

        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import sha256 from 'js-sha256'
import { api } from '@src/modules/forgetpassword/api/index.js'
import utils from '@src/common/utils'
export default {
  data () {
    return {
      loading: false,
      accountNumber: '',
      param: {
        password: '',
        confirmPassword: ''
      },
      //用于改变Input类型
      passw: "password",
      confirmpassw: "password",
      icon: "el-input__icon el-icon-view",
      icon1: "el-input__icon el-icon-view",
      codetext: true,
      disableButton: false,
      timerCount: this.codewaite,
      focusType: '',
      show: true,
      count: '',
      timer: null,

    }
  },
  created () {
    this.accountNumber = this.$route.query.accountNumber;
    this.identifycode = this.$route.query.identifycode;

  },
  methods: {
    showPass () {
      if (this.passw == "text") {
        this.passw = "password";
        //更换图标
        this.icon = "el-input__icon el-icon-view";
      } else {
        this.passw = "text";
        this.icon = "el-input__icon el-icon-loading";
      }
    },
    showPass1 () {
      if (this.confirmpassw == "text") {
        this.confirmpassw = "password";
        //更换图标
        this.icon1 = "el-input__icon el-icon-view";
      } else {
        this.confirmpassw = "text";
        this.icon1 = "el-input__icon el-icon-loading";
      }
    },
    clearText (key) {
      this.param[key] = '';
      this.icon = "el-input__icon el-icon-view";
    },
    reback () {
      this.$router.push({
        path: '/forgetPassword',
      })
    },
    getCode () {
      if (this.disableButton) {
        return;
      } else {
        this.codetext = false;
        const TIME_COUNT = 10;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.disableButton = true;
              this.count--;
            } else {
              this.show = true;
              this.disableButton = false;
              clearInterval(this.timer);
              this.timer = null;
              this.codetext = true;
            }
          }, 1000)
        }
        console.log("vertifycode");
        console.log(this.accountNumber, '=====this.accountNumber');
        this.$fetch(api.queryVerificationCode, { accountNumber: this.accountNumber })
          .then((res) => {
            console.log(res, '===验证码');
            this.newpassword = "1122";
            this.verificationCode = res.rturnObj.verificationCode;
          })
        /* this.$emit('getVerifyCode')
        uni.$off('verifycodeSuccess', this.verifycodeSuccess)
        uni.$on('verifycodeSuccess', this.verifycodeSuccess) */
      }
    },
    confirm () {
      const params = {
        accountNumber: this.accountNumber,
        verificationCode: this.identifycode,
        password: sha256(this.param.password),
        confirmPassword: sha256(this.param.confirmPassword)
      }
      this.$fetch(api.resetPassword, params)
        .then(res => {
          // /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,16}$/
          var passwordreg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/
          if (!passwordreg.test(this.param.password) && !passwordreg.test(this.param.confirmPassword)) {
            this.$message({ type: 'error', message: '密码必须为6-10位密码的数字和字母!' })

          } else if (res.msgCode == "0") {
            this.$message({ type: 'success', message: "密码修改成功，退出登录" })
            this.$router.push({
              path: '/Login'
            })
          } else {
            console.log('error');
            this.$message({ type: 'error', message: res.msgContent })
          }

          // if (this.newpassword ==this.confirmPassword) {
          //    this.$message({ type: 'success', message: "密码重置成功" })
          //   this.$router.push({
          //     path: '/Login'
          //   })
          // }else if(this.newpassword !=this.confirmPassword){
          //    this.$message({ type: 'error', message: "两次输入密码不一致" })
          // }else{
          //    this.$message({ type: 'error', message: res.msgContent })
          // }
        })

    }
  }
}
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.newpassword-page {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  margin: 0;
  position: absolute;
  overflow: hidden;

  left: 0;
  top: 0;
 .back{
    margin-top: 10px;
    font-size: 14px;
  }
  .el-input__inner {
    border: none !important;
    background: transparent !important;
    height: 40px !important;
    line-height: 40px !important;
  }
  .newpassword-main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .newpassword-container {
      margin-top: 80px;
      @include set_theme_color(background-color, blur-color);
      width: 380px;
      height: 400px;
      padding: 20px;
      border-radius: 5px;
      position: relative;
      // background-color: rgba(0, 8, 75, 0.8);
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .newpassword-form {
        width: 100%;
        top: 50px;
        .newpassword-label {
          font-size: 14px;
          .account-number {
            color: #66b1ff;
          }
        }
        .form-item {
          position: relative;

          .newpassword-title {
            font-size: 24px;
            text-align: center;
            margin-bottom: 30px;
            border-bottom: 2px solid;
            @include set_theme_color(border-color, top-menu-border-color);
          }
        }
        .form-code {
          position: relative;
          .input-text {
            padding-left: 8px;
            height: 40px;
          }
          .form-input {
            // width: 40px;
            height: 40px;
            padding: 0 20px 0 40px;
            width: 100%;
            position: relative;
            @include set_theme_color(background-color, top-menu-bg-color);
            -moz-box-shadow: none !important;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            border: 1px solid;
            @include set_theme_color(border-color, top-menu-border-color);
            @include set_theme_color(color, font-default-color);

            &:hover {
              @include set_theme_color(border-color, active-border-color);
            }

            &:focus {
              @include set_theme_color(border-color, active-border-color);
            }
          }
          .form-input-icon {
            position: absolute;
            top: 0px;
            left: 0px;
            width: 40px;
            height: 40px;
            text-align: center;

            i {
              font-size: 20px;
              line-height: 40px;
            }
          }
        }

        .sign-button {
          width: 100%;
          margin-top:40px;
        }
      }
    }
  }
}
</style>